import CONSTANTS from '../constants'
import { postRequest } from '../../services'
import { APICONFIG } from '../apiConfig'

// Calls the API to get EVENT Initials
export const getEventDetails = (postData) => (dispatch) => {
	dispatch({ type: CONSTANTS.EVENT_INITIAL_REQUEST })
	return postRequest(APICONFIG.getEventListUrl,postData).then((res) => {		
		dispatch({ type: CONSTANTS.EVENT_INITIAL_SUCCESS, data: res })
		return res
	}).catch(() => {
		dispatch({ type: CONSTANTS.EVENT_INITIAL_FAILURE })
	})
}

//pass details
export const getPassDetails = (postData) => (dispatch) => {
	dispatch({ type: CONSTANTS.PASS_INITIAL_REQUEST })
	return postRequest(APICONFIG.getPassListUrl,postData).then((res) => {		
		dispatch({ type: CONSTANTS.PASS_INITIAL_SUCCESS, data: res })
		return res
	}).catch(() => {
		dispatch({ type: CONSTANTS.PASS_INITIAL_FAILURE })
	})
}

export const updateEventState = (update) => dispatch => {
	dispatch({ type: CONSTANTS.UPDATE_EVENT_STATE, update })
}
